<div class="heap-progress-bar-wrapper">
  <div class="heap-progress-bar-title"><span class="memory-size"></span><span class="property-title">Heap Memory</span><span class="memory-size"></span></div>
  <div class="heap-progress-bar-custom" style="--width: 0; --pseudoEl: 'lightgreen'" [ngStyle]="{'--width' :  progressWidth()}">
  </div>
</div>

